export const GRID_SIZING_VIEW = 'grid';
export const PROPORTIONAL_SIZING_VIEW = 'proportional';